module.exports = __webpack_public_path__ + "static/img/punsukEvent.a9b839e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/punsukEvent.png
// module id = FZfE
// module chunks = 2